"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVerticalIllustration = exports.isHorizontalIllustration = exports.handleOnErrorWithFallback = exports.getSpotUrl = exports.getFallbackIllustration = exports.getErrorMessage = exports.getDimensionsBySize = exports.getAspectRatioByName = void 0;
var _SpotIllustration = require("./SpotIllustration.types");
var _i18n = require("../../i18n");
var _theming = require("../../theming");
var _constants = require("../../theming/constants");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var VERTICAL_SPOT_ILLUSTRATIONS = [_SpotIllustration.Name.DOCUMENTS_PAYMENT_STATEMENT, _SpotIllustration.Name.REPAIR_TOOLS, _SpotIllustration.Name.SCENIC_SPOTS_AGENT_DESK_NOTIFICATION, _SpotIllustration.Name.SCENIC_SPOTS_AGENT_OUTSIDE_DOOR, _SpotIllustration.Name.SCENIC_SPOTS_AGENT_WITH_PEOPLE_IN_ROW, _SpotIllustration.Name.SCENIC_PROPERTY_NOT_FOUND, _SpotIllustration.Name.SCENIC_SPOTS_CELEBRATE, _SpotIllustration.Name.SCENIC_SPOTS_KEY, _SpotIllustration.Name.SCENIC_SPOTS_SAD_PEOPLE_LOOKING_WINDOW, _SpotIllustration.Name.SCENIC_SPOTS_VISITS, _SpotIllustration.Name.SCENIC_SPOTS_VISIT_CALENDAR, _SpotIllustration.Name.STATUS_LOCALIZATION, _SpotIllustration.Name.STATUS_NO_INTERNET];
var HORIZONTAL_SPOT_ILLUSTRATIONS = [_SpotIllustration.Name.FINANCE_MONEY, _SpotIllustration.Name.GESTURES_AGREEMENT, _SpotIllustration.Name.GESTURES_POINT, _SpotIllustration.Name.HOMES_FINDING, _SpotIllustration.Name.OBJECTS_ALARM_CLOCK, _SpotIllustration.Name.OBJECTS_BIKE, _SpotIllustration.Name.OBJECTS_CAR, _SpotIllustration.Name.OBJECTS_FOOD, _SpotIllustration.Name.SCENIC_SPOTS_COMMUTING, _SpotIllustration.Name.SCENIC_SPOTS_INSPECTION_TYPE_1, _SpotIllustration.Name.SCENIC_SPOTS_PHOTOGRAPHER, _SpotIllustration.Name.SCENIC_SPOTS_TOAST, _SpotIllustration.Name.SOCIAL_SOCIAL_NETWORKS, _SpotIllustration.Name.STATUS_ALERT, _SpotIllustration.Name.CITY_HOUSE_SEARCH];
var isVerticalIllustration = exports.isVerticalIllustration = function isVerticalIllustration(name) {
  return VERTICAL_SPOT_ILLUSTRATIONS.includes(name);
};
var isHorizontalIllustration = exports.isHorizontalIllustration = function isHorizontalIllustration(name) {
  return HORIZONTAL_SPOT_ILLUSTRATIONS.includes(name);
};
var getAspectRatioByName = exports.getAspectRatioByName = function getAspectRatioByName(name) {
  if (isVerticalIllustration(name)) return '11 / 16';
  if (isHorizontalIllustration(name)) return '16 / 11 auto';
  return 'auto';
};
var getDimensionsBySize = exports.getDimensionsBySize = function getDimensionsBySize(size) {
  var _Size$SMALL$Size$MEDI;
  return (_Size$SMALL$Size$MEDI = {}, _defineProperty(_Size$SMALL$Size$MEDI, _SpotIllustration.Size.SMALL, '150px'), _defineProperty(_Size$SMALL$Size$MEDI, _SpotIllustration.Size.MEDIUM, '280px'), _defineProperty(_Size$SMALL$Size$MEDI, _SpotIllustration.Size.LARGE, '400px'), _defineProperty(_Size$SMALL$Size$MEDI, _SpotIllustration.Size.XLARGE, '550px'), _Size$SMALL$Size$MEDI)[size];
};
var getSpotUrl = exports.getSpotUrl = function getSpotUrl(name, specificTheme) {
  var _useTheme = (0, _theming.useTheme)(),
    _useTheme$name = _useTheme.name,
    wrappedTheme = _useTheme$name === void 0 ? _theming.Theme.DEFAULT : _useTheme$name;
  var locale = (0, _i18n.getLocale)();
  var PACKAGE_VERSION = "".concat(_constants.PACKAGE, "/").concat(_constants.COZY_STATIC_MAJOR_VERSION, "/latest");
  var CURRENT_THEME = specificTheme || wrappedTheme;
  var SPOT_ASSET = "".concat(_constants.ASSET, "/spots");
  return "".concat(_constants.DOMAIN, "/").concat(PACKAGE_VERSION, "/").concat(CURRENT_THEME, "/").concat(SPOT_ASSET, "/").concat(name, ".").concat(locale, ".webp");
};
var handleOnErrorWithFallback = exports.handleOnErrorWithFallback = function handleOnErrorWithFallback(fallbackSrc) {
  return function (event) {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = fallbackSrc;
  };
};
var getFallbackIllustration = exports.getFallbackIllustration = function getFallbackIllustration(fallbackSrc) {
  return {
    onError: handleOnErrorWithFallback(fallbackSrc)
  };
};
var getErrorMessage = exports.getErrorMessage = function getErrorMessage(spotName) {
  return "\n \"".concat(spotName, "\" name is not an illustration spot available!   \n The illustration does not exist or the name wasn't write using kebab-case.   \n Check all available illustrations on figma Illustration Library file: https://www.figma.com/file/wXwANpdZ7oCJSg9mYr2o4x/Cozy-Illustrations?node-id=0%3A1");
};